import router from './router';
import Nprogress from 'nprogress';
import 'nprogress/nprogress.css';
import { Route } from 'vue-router';

const DEFAULT_COMPANY = 'get';

const getCompanyValue = (route: Route) => {
  const company = route.query.company;
  if (Array.isArray(company)) {
    return company[0] || '';
  }
  return company || '';
};

Nprogress.configure({ showSpinner: false });

router.beforeEach((to, from, next) => {
  Nprogress.start();

  const company = getCompanyValue(to);
  if (company) {
    next();
    return;
  }

  const fallbackCompany = getCompanyValue(from) || DEFAULT_COMPANY;
  next({
    path: to.path,
    query: {
      ...to.query,
      company: fallbackCompany,
    },
    hash: to.hash,
    replace: true,
  });
});

router.afterEach(() => {
  Nprogress.done();
});
